<main class="page-content">
  <div class="page-header">
    <div>
      <h1>Welcome back, {{ firstName() }}!</h1>
      <p>Here is what's happening with your organization today.</p>
    </div>

    <button mat-raised-button color="primary" routerLink="/employees">
      <mat-icon>add</mat-icon>
      Add Employee
    </button>
  </div>

  @if (loading) {
    <div class="loading-row">
      <mat-spinner diameter="36"></mat-spinner>
      <span>Loading dashboard…</span>
    </div>
  }

  @if (error) {
    <mat-card class="error-card">
      <mat-icon>error_outline</mat-icon>
      <span>{{ error }}</span>
      <button mat-button color="primary" type="button" (click)="loadDashboard()">Retry</button>
    </mat-card>
  }

  <div class="stats-grid">
    <mat-card class="stat-card" *ngFor="let stat of stats">
      <div class="stat-content">
        <div>
          <span class="stat-title">{{ stat.title }}</span>
          <h2>{{ stat.value }}</h2>
          <span class="stat-change">{{ stat.change }}</span>
        </div>
        <div class="stat-icon" [ngClass]="stat.type">
          <mat-icon>{{ stat.icon }}</mat-icon>
        </div>
      </div>
    </mat-card>
  </div>

  <div class="dashboard-grid">
    <mat-card class="dashboard-card employee-card">
      <div class="card-header">
        <div>
          <h2>Recent Employees</h2>
          <p>Latest workforce records</p>
        </div>
        <button mat-button color="primary" routerLink="/employees">View All</button>
      </div>

      <div class="table-container">
        <table mat-table [dataSource]="employees" class="employee-table">
          <ng-container matColumnDef="employee">
            <th mat-header-cell *matHeaderCellDef>Employee</th>
            <td mat-cell *matCellDef="let employee">
              <div class="employee-info">
                <div class="employee-avatar">{{ employee.avatar }}</div>
                <div>
                  <strong>{{ employee.name }}</strong>
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="department">
            <th mat-header-cell *matHeaderCellDef>Department</th>
            <td mat-cell *matCellDef="let employee">{{ employee.department }}</td>
          </ng-container>

          <ng-container matColumnDef="designation">
            <th mat-header-cell *matHeaderCellDef>Designation</th>
            <td mat-cell *matCellDef="let employee">{{ employee.designation }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let employee">
              <span
                class="status-badge"
                [class.present]="employee.status === 'Present' || employee.status === 'Active'"
                [class.leave]="employee.status === 'On Leave' || employee.status === 'Inactive'">
                {{ employee.status }}
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        @if (!employees.length) {
          <p class="empty-hint">No employees loaded yet.</p>
        }
      </div>
    </mat-card>

    <mat-card class="dashboard-card leave-card">
      <div class="card-header">
        <div>
          <h2>Leave Requests</h2>
          <p>Pending approval requests</p>
        </div>
        <span class="request-count">{{ leaveRequests.length }}</span>
      </div>

      <div class="leave-list">
        <div class="leave-item" *ngFor="let leave of leaveRequests">
          <div class="leave-info">
            <strong>{{ leave.employee }}</strong>
            <span>{{ leave.type }}</span>
            <small>{{ leave.dates }}</small>
          </div>

          <div class="leave-actions" *ngIf="isLeaveActionable(leave.status)">
            <button
              mat-icon-button
              class="approve-button"
              type="button"
              [disabled]="leave.busy"
              (click)="approveLeave(leave)">
              <mat-icon>check</mat-icon>
            </button>
            <button
              mat-icon-button
              class="reject-button"
              type="button"
              [disabled]="leave.busy"
              (click)="rejectLeave(leave)">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <span
            *ngIf="!isLeaveActionable(leave.status)"
            class="status-badge"
            [class.present]="leave.status === 'Approved'"
            [class.leave]="leave.status === 'Rejected' || leave.status === 'Cancelled'">
            {{ leave.status }}
          </span>
        </div>

        @if (!leaveRequests.length) {
          <p class="empty-hint">No leave requests.</p>
        }
      </div>
    </mat-card>
  </div>

  <div class="bottom-grid">
    <mat-card class="dashboard-card">
      <div class="card-header">
        <div>
          <h2>Department Distribution</h2>
          <p>Employees by department</p>
        </div>
      </div>

      <div class="department-list">
        <div class="department-item" *ngFor="let department of departments">
          <div class="department-header">
            <span>{{ department.name }}</span>
            <strong>{{ department.employees }}</strong>
          </div>
          <mat-progress-bar mode="determinate" [value]="department.percentage"></mat-progress-bar>
          <span class="percentage">{{ department.percentage }}%</span>
        </div>

        @if (!departments.length) {
          <p class="empty-hint">No departments loaded.</p>
        }
      </div>
    </mat-card>

    <mat-card class="dashboard-card">
      <div class="card-header">
        <div>
          <h2>Quick Actions</h2>
          <p>Frequently used HR functions</p>
        </div>
      </div>

      <div class="quick-actions">
        <button mat-stroked-button routerLink="/employees">
          <mat-icon>person_add</mat-icon>
          Add Employee
        </button>
        <button mat-stroked-button routerLink="/attendance">
          <mat-icon>event_available</mat-icon>
          Mark Attendance
        </button>
        <button mat-stroked-button routerLink="/leave">
          <mat-icon>calendar_month</mat-icon>
          Manage Leaves
        </button>
        <button mat-stroked-button routerLink="/payroll">
          <mat-icon>payments</mat-icon>
          Process Payroll
        </button>
      </div>
    </mat-card>
  </div>
</main>
